namespace $ {

	export type $shm_hitalama_vk_group_dto = {
		id: string,
		name: string,
		photo_50: string,
		members_count: number 
	}

	export class $shm_hitalama_vk_group extends $giper_baza_entity.with({

		Name: $giper_baza_atom_text,
		Group_id: $giper_baza_atom_text,
		Owner_id: $giper_baza_atom_text,
		Photo_url: $giper_baza_atom_text,
		Members_count: $giper_baza_atom_real,
		
	}){

		fill( dto: $shm_hitalama_vk_group_dto ) {
			this.Name(null)?.val( dto?.name )
			this.Group_id(null)?.val( dto?.id )
			this.Owner_id(null)?.val( '-' + dto?.id )
			this.Photo_url(null)?.val( dto?.photo_50 )
			this.Members_count(null)?.val( dto?.members_count )
		}
		
	}
	
}
